import type { DashboardChildNavItem, DashboardInfo } from "./types";

export function countChildDashboards(
  children: DashboardChildNavItem[] | undefined,
): number {
  return children?.length ?? 0;
}

export function countDashboardsWithChildren(
  dashboards: Pick<DashboardInfo, "child_dashboards">[],
): number {
  return dashboards.reduce(
    (total, dashboard) =>
      total + 1 + countChildDashboards(dashboard.child_dashboards),
    0,
  );
}

export function formatDashboardCountLabel(count: number): string {
  return `${count} ${count === 1 ? "Dashboard" : "Dashboards"}`;
}
